import { adminConstants } from '../constant/admin-constant';

const initialState = {loading: false, emailTemplatesList:[], emailTemplates:[], emailTypes:[], emailTemplate:null, mailTemplatesDD: []};
export function emailTemplateReducer(state = initialState, action){
	switch(action.type){

		case adminConstants.GET_EMAIL_TEMPLATES_REQUEST:
			return { ...state, loading:true };
		case adminConstants.GET_EMAIL_TEMPLATES_SUCCESS:
			return { ...state, loading:false, emailTemplatesList : action.payload.emailTemplates };
		case adminConstants.GET_EMAIL_TEMPLATES_FAILURE:
			return { ...state, loading:false, error : action.payload };

		case adminConstants.GET_EMAIL_TYPES_REQUEST:
			return { ...state, loading:true };
		case adminConstants.GET_EMAIL_TYPES_SUCCESS:
			return { ...state, loading:false, emailTypes : action.payload.emailTypes };
		case adminConstants.GET_EMAIL_TYPES_FAILURE:
			return { ...state, loading:false, error : action.payload };

		case adminConstants.STORE_EMAIL_TEMPLATES_REQUEST:
			return { ...state, loading:true };
		case adminConstants.STORE_EMAIL_TEMPLATES_SUCCESS:
			return { ...state, loading:false, emailTemplate : action.payload.emailTemplate };
		case adminConstants.STORE_EMAIL_TEMPLATES_FAILURE:
			return { ...state,loading:false, error : action.payload };

		case adminConstants.EDIT_EMAIL_TEMPLATES_REQUEST:
			return { ...state, loading:true };
		case adminConstants.EDIT_EMAIL_TEMPLATES_SUCCESS:
			return { ...state, loading:false, emailTemplate : action.payload.emailTemplate };
		case adminConstants.EDIT_EMAIL_TEMPLATES_FAILURE:
			return { ...state,loading:false, error : action.payload };

		case adminConstants.DELETE_EMAIL_TEMPLATES_REQUEST:
			return { ...state, loading:true }
		case adminConstants.DELETE_EMAIL_TEMPLATES_SUCCESS:
			return { ...state, loading:false};
		case adminConstants.DELETE_EMAIL_TEMPLATES_FAILURE:
			return { ...state, loading:false, error:action.payload };

		case adminConstants.GET_EMAIL_TEMPLATE_REQUEST:
			return { ...state, loading:true };
		case adminConstants.GET_EMAIL_TEMPLATE_SUCCESS:
			return { ...state, loading:false, emailTemplate : action.payload.emailTemplate, emailTemplates : action.payload.emailTemplates, mailTemplatesDD : action.payload.mailTemplatesDD  };
		case adminConstants.GET_EMAIL_TEMPLATE_FAILURE:
			return { ...state, loading:false, error : action.payload };

		default:
			return { ...state };
	}
}


// WEBPACK FOOTER //
// ./src/redux/reducers/EmailTemplateReducer.jsx